
import React from 'react'
import { Link } from 'react-router-dom'
import "./HeroimgStyle.css"
import IntroImg from "../components/asserts/intro-bg.jpg"

const Heroimg = () => {
  return (
    <div className='hero'>
      <div className='mask'>
         <img className='intro-img' src={IntroImg} alt="IntroImg"></img>
      </div>
      <div className='content'>
        <p>Hi,i'm freelancer</p>
        <h1>react developer</h1>
        <div>
            <Link to="Project/" className='btn'>Projects</Link>
            <Link to="Contact/" className='btn btn-light'>Contact</Link>
        </div>
      </div>
    </div>
  )
}

export default Heroimg
